import { Injectable } from '@angular/core';
import { AddressBookService } from './address-book.service';

@Injectable({ providedIn: 'root' })
export class AddressBookResolver {
  constructor(private addressBookService: AddressBookService) {}

  resolve() {
    return this.addressBookService.fetchAddressBook();
  }
}
